var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-108d7b31-db76-4e46-a5e4-6f010e00ccb2",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 525.5 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-cb38c7ea-a161-4304-b371-3c07564b4c0e {\r\n        fill: #2c2c2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-cb38c7ea-a161-4304-b371-3c07564b4c0e",
    d: "M494.12,154.22c-17.35,0-31.38,14.04-31.38,31.38v631.67c0,110.27-89.71,199.95-199.98,199.95s-199.98-89.68-199.98-199.95V185.61c0-67.73,55.11-122.84,122.87-122.84s122.84,55.11,122.84,122.84v637.43c0,25.19-20.5,45.73-45.73,45.73s-45.73-20.53-45.73-45.73V156.86c0-17.35-14.04-31.38-31.38-31.38s-31.38,14.04-31.38,31.38v666.18c0,59.83,48.67,108.5,108.5,108.5s108.5-48.67,108.5-108.5V185.61C371.25,83.24,287.98,0,185.64,0S0,83.24,0,185.61v634.86h.32c1.76,143.34,118.64,259.53,262.43,259.53s262.75-117.88,262.75-262.72V185.61c0-17.35-14.04-31.38-31.38-31.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/ClipIcon.dc284df6f89b9c7ee69c849f478b91b0.svg";
export { ForwardRef as ReactComponent };